import React, { useState } from "react";
import { FiEdit3, FiGrid, FiZap } from "react-icons/fi";

const STORAGE_KEY = "scribbledraw-welcome-seen";

const STEPS = [
  {
    icon: FiEdit3,
    animClass: "welcome-icon-wiggle",
    title: "Draw or upload",
    description:
      "Sketch your idea on the canvas, or drag & drop an image to draw on top of it.",
  },
  {
    icon: FiGrid,
    animClass: "welcome-icon-pulse",
    title: "Pick a style",
    description:
      "Choose from logo, sprite, pixel art, icon, sticker, or illustration.",
  },
  {
    icon: FiZap,
    animClass: "welcome-icon-bounce",
    title: "Select & generate",
    description:
      "Select your drawing, then hit generate. Download your polished asset as PNG.",
  },
];

export default function WelcomeModal() {
  const [visible, setVisible] = useState(
    () => !localStorage.getItem(STORAGE_KEY)
  );

  if (!visible) return null;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 2000,
        padding: "20px",
      }}
      onClick={handleDismiss}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "16px",
          padding: "40px 36px 32px",
          maxWidth: "520px",
          width: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
          fontFamily: "'Inter', sans-serif",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{
            fontSize: "24px",
            fontWeight: 800,
            letterSpacing: "-0.02em",
            marginBottom: "4px",
            textAlign: "center",
            color: "#111",
          }}
        >
          Welcome to scribbledraw.
        </h2>
        <p
          style={{
            fontSize: "14px",
            color: "#888",
            textAlign: "center",
            marginBottom: "32px",
          }}
        >
          Turn rough sketches into polished assets in seconds.
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "32px",
          }}
        >
          {STEPS.map((step, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
              }}
            >
              <div
                className={step.animClass}
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "12px",
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <step.icon size={20} color="#333" />
              </div>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#111",
                    marginBottom: "2px",
                  }}
                >
                  {step.title}
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "#666",
                    lineHeight: 1.5,
                  }}
                >
                  {step.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={handleDismiss}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            width: "100%",
            padding: "14px",
            fontSize: "14px",
            fontWeight: 600,
            letterSpacing: "0.02em",
            color: "#fff",
            backgroundColor: "#000",
            border: "none",
            borderRadius: "12px",
            cursor: "pointer",
            transition: "transform 0.15s ease, box-shadow 0.15s ease",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.02)";
            e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.15)";
          }}
        >
          START CREATING
          <span style={{ fontSize: "16px", lineHeight: 1 }}>&rarr;</span>
        </button>
      </div>
    </div>
  );
}
